import MyManager from './components/my-manager';
import MyApprove from './components/my-approve';
import AddChannel from './components/add-channel/index';
export default [
  {
    path: '/my-manager',
    title: '我管理的',
    component: MyManager,
  },
  {
    path: '/my-approve',
    title: '审核管理',
    component: MyApprove,
  },
  {
    path: '/add-channel',
    title: '新建微频道',
    component: AddChannel,
    hideInNav: true,
  },
  {
    path: '/edit-channel',
    title: '编辑微频道',
    component: AddChannel,
    hideInNav: true,
  },
];
